import React, { useState } from "react";
import "./CheckoutLottery.scss";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Back from "../../../img/back.png";
import { formatTaxId } from "../../../utils/formats";

function CheckoutLottery(props) {
  const { t } = useTranslation();
  const [videoState, setVideoState] = useState(false);
  return (
    <div className="checkoutLottery">
      <div className="checkoutLottery__title">
        <p>Este meio de pagamento não é via boleto bancário. Pague na lotérica utilizando os dados abaixo:</p>
      </div>
      <div className="checkoutLottery__contentContainer">
        <div className="checkoutLottery__content">
          <p className="checkoutLottery__contentText">Código do convênio</p>
          <p className="checkoutLottery__contentValue">{props.payData?.bank_no}</p>
        </div>
        <div className="checkoutLottery__content">
          <p className="checkoutLottery__contentText">Número de CPF/CNPJ</p>
          <p className="checkoutLottery__contentValue">
            {props.payData?.userCPF ||
              formatTaxId(props.tradeInfo?.user?.identification?.number, "BRA", props.tradeInfo?.user?.identification?.type)}
          </p>
        </div>
      </div>
      <div className="checkoutLottery__instContainer">
        <p>
          Dúvida ao realizar o pagamento？Clique{" "}
          <span
            className="checkoutLottery__instContainer__click"
            onClick={() => {
              setVideoState(true);
            }}
          >
            aqui
          </span>{" "}
          e assista ao vídeo explicativo.
        </p>
        <p>A aprovação acontece em até 1 hora após o pagamento</p>
      </div>
      {videoState && (
        <div
          className="checkoutLottery__videoContainer"
          onClick={() => {
            setVideoState(false);
          }}
        >
          <div className="checkoutLottery__iframeContainer">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/Vw8Iib_uGeE"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <img
              src={Back}
              alt=""
              onClick={() => {
                setVideoState(false);
              }}
              className="checkoutLottery__iframeContainer__back"
            />
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state, ownprops) => {
  return {
    tradeInfo: state.tradeInfo,
    paymentInfo: state.paymentInfo,
    payData: state.payData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutLottery);
